import { cn } from '@/lib/utils'

const BASE_CLASSES = 'font-main-font transition-colors duration-300 inline-flex items-center'

const VARIANT_CLASSES = {
  default: 'text-text-color hover:text-text-color/80 focus:text-text-color active:text-text-color visited:text-text-color',
  light: 'text-white hover:text-white/80 focus:text-white active:text-white visited:text-white',
  muted: 'text-custom-gray hover:text-current',
  underline: 'text-text-color underline hover:text-text-color/80 focus:text-text-color active:text-text-color visited:text-text-color',
} as const

const SIZE_CLASSES = {
  sm: 'text-sm',
  base: 'text-sm xl:text-base',
} as const

interface TextLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: keyof typeof VARIANT_CLASSES
  size?: keyof typeof SIZE_CLASSES
  external?: boolean
}

/**
 * TextLink - Consistent text link styling across the project
 *
 * Self-contained UiBlock with baked-in project styles.
 */
export function TextLink({
  variant = 'default',
  size = 'sm',
  external = false,
  className,
  children,
  ...props
}: TextLinkProps) {
  const externalProps = external
    ? { target: '_blank' as const, rel: 'noopener noreferrer' }
    : {}

  return (
    <a
      className={cn(BASE_CLASSES, VARIANT_CLASSES[variant], SIZE_CLASSES[size], className)}
      {...externalProps}
      {...props}
    >
      {children}
    </a>
  )
}
